// extracted by mini-css-extract-plugin
export default {"wrapper":"Phases_wrapper__SwA8i","buttonWrap":"Phases_buttonWrap__yaqGh","cancelBtn":"Phases_cancelBtn__SB3Er","titleWrap":"Phases_titleWrap__6BCbl"};